import { Component, Host, h } from '@stencil/core';

@Component({
  tag: 'me-main-layout',
  styleUrl: 'me-main-layout.scss',
  shadow: false,
})
export class MeMainLayout {

  render() {
    return (
      <Host class="me-main-layout">
        <me-backdrop />
        <header class="me-main-layout__header">
          <slot name="header"></slot>
        </header>
        <nav class="me-main-layout__breadcrumbs">
          <slot name="breadcrumbs"></slot>
        </nav>
        <main class="me-main-layout__main">
          <slot name="main"></slot>
        </main>
        <footer class="me-main-layout__footer">
          <slot name="footer"></slot>
        </footer>
      </Host>
    );
  }

}
